import { Navigate } from "react-router-dom";
import { isTenantAuthenticated } from "../tenant/pages/TenantAuth";
import { isPhaseAdmin } from "../utils/role";

const SESSION_KEY = "zangon_session";

function getSession() {
  try {
    return JSON.parse(localStorage.getItem(SESSION_KEY) || "null");
  } catch {
    return null;
  }
}

export function isAdminAuthenticated() {
  return !!getSession()?.accessToken;
}

// Where a signed-in user belongs; null when nobody is signed in.
export function getHomeRoute() {
  if (isAdminAuthenticated()) return "/dashboard";
  if (isTenantAuthenticated()) return "/tenant/dashboard";
  return null;
}

export function HomeRedirect() {
  return <Navigate to={getHomeRoute() || "/sign-in"} replace />;
}

export default function ProtectedRoute({ children, estateOnly = false }) {
  if (!isAdminAuthenticated()) {
    // A signed-in tenant who lands on an admin page goes to their own dashboard.
    return <Navigate to={isTenantAuthenticated() ? "/tenant/dashboard" : "/sign-in"} replace />;
  }

  // Phase Administrators are bounced from estate-level pages.
  if (estateOnly && isPhaseAdmin()) return <Navigate to="/dashboard" replace />;

  return children;
}
